import { Filter } from "lucide-react";
import { FilterConfig, ProductListConfig } from "@b2b/ui-components";

// Filters config
export const userFilters: FilterConfig[] = [
  {
    type: "button",
    label: "Filters",
    icon: Filter,
    variant: "outline",
  },
];

// Table config
export const userTableConfig: ProductListConfig = {
  columns: [
    { key: "user", label: "User" },
    { key: "email", label: "Email" },
    { key: "type", label: "Type" },
    { key: "status", label: "Status" },
    { key: "joinDate", label: "Join Date" },
    { key: "company", label: "Company" },
    { key: "actions", label: "Actions", align: "right" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      active: { background: "bg-green-100", textColor: "text-green-700" },
      pending: { background: "bg-yellow-100", textColor: "text-yellow-700" },
      suspended: { background: "bg-red-100", textColor: "text-red-700" },
    },
  },
};
